import { Button, Input, InputNumber } from "antd"
import { Typography,Modal } from 'antd';
import styled from "styled-components";
import {DeleteFilled,ExclamationCircleOutlined} from "@ant-design/icons/lib/icons"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth ,db} from "../Config";
import {doc, query, orderBy,onSnapshot, collection,deleteDoc,getDoc} from "firebase/firestore";
const CartContainer = styled.div`
        margin:15vh 0vw 8vh 18vw;
        width:55vw;
        min-height:80vh;
        display:flex;
        flex-direction:column;
        @media (max-width:767px){
            width:94vw;
            margin:15vh 0vw 8vh 0vw;
        }
        .cart-title{
            font-size:1.3vmax;
            margin-bottom:3vh;
            color:tomato;
            @media (max-width:767px){
                margin-left:3vw;
                font-size:4vmin;
            }
        }
    `
const ProductItem = styled.div`
        width:100%;
        margin:0 3vw 3vh 3vw;
        height:20vh;
        background-color:white;
        border-radius:20px;
        border:1.5px solid tomato;
        display:flex;
        align-items:center;
        .delete-icon{
            width:10%;
            font-size:1.2vmax;
            :hover{
                color:tomato;
                transition:0.25s all ease;
                cursor:pointer;
            }
            @media (max-width:767px){
                font-size:3vmax;
            }
        }
        @media (max-width:1023px) and (min-width:768px){
            height:18vh;
        }
        
    `
    const ImgDiv = styled.div`
    margin-left:2vw;
    width:20%;
    height:85%;
    margin-top:2vh;
    .Item-img{
        width:100%;
        height:100%;
        object-fit:cover;
    }
    :hover{
        cursor:pointer;
    }
    @media (max-width:767px){
        width:35%;    
    }
`
const ItemInfo = styled.div`
        width:65%;
        height:100%;
        margin-left:0.5vw;
        :hover{
            cursor:pointer;
        }
        .cartitem-name{
            font-size:1.3vmax;
            margin-top:1vh;
            @media (max-width:1023px) and (min-width:768px){
                font-size:1.5vmin;
            }
            @media (max-width:767px){
                font-size:3vmin;
            }
        }
        display:flex;
        flex-direction:column;
        justify-content:space-evenly;
        
    `
const OtherInfo = styled.div`
        display:flex;
        flex-direction:column;
        justify-content:space-evenly;
        flex-grow:3;
        .cartitem-sizenum{
            margin-right:1vw;
            margin-bottom:0;
            font-size:1vmax;
            @media (max-width:767px){
                font-size:3vmin;
            }
        }
        .cartitem-cost{
            font-size:1vmax;
            color: tomato;
            margin:0 0 0 0;
            @media (max-width:767px){
                font-size:3vmin;
            }
        }
    `
    const BuyAllItem = styled.div`
        width:20vw;  
        margin-left:3vw;
        margin-top:15vh;
        margin-right:1vw;
        height:20vh;
        display:flex;
        flex-direction:column;
        justify-content:space-evenly;
        border:1px solid black;
        border-radius:30px;
        position:fixed;
        right:0;
        @media (max-width:767px){
            bottom:0;
            width:100vw;
            margin:0;
            border-top: 1px solid tomato;
            border-radius:0;
            border-left:0;
            border-right:0;
            border-bottom:0;
            background-color:white;
        }
        .total-title{
            margin:0 0 0 1vw;
            font-size:1.1vmax;
            @media (max-width:767px){
                font-size:3vmin;
                margin-left:2vw;
            }
        }
        .total-cost{
            margin:0 0 0 1vw;
            font-size:1.1vmax;
            color: tomato;
            @media (max-width:767px){
                font-size:3vmin;
                margin-left:2vw;
            }
        }
        .total-btn{
            width:90%;
            height:5vh;
            font-size:1.1vmax;
            color: white;
            border-radius:10px;
            background-color:tomato;
            margin-left:1vw;
            @media (max-width:767px){
                font-size:3vmin;
                margin-left:2vw;
                width:95%;
                height:7vh;
            }
        }
    `
    
export default function Cart(){
    const { Title } = Typography;
    const [cart,setCart] = useState([])
    let navigate = useNavigate()
    const [totalCost,setTotalCost] = useState(0)
    useEffect(()=>{
        const cartRef = collection(db,'cartlist',auth.currentUser.uid,'cart')
        const c = query(cartRef,orderBy('createAt','desc'))
        onSnapshot(c,querySnapshot=>{
            let cart=[]
            querySnapshot.forEach(doc=>{
                cart.push(doc.data())
            })
            setCart(cart)
        })
    },[])
    useEffect(()=>{
        setTotalCost(0)
        cart.map((item)=>{
            setTotalCost(prev=>prev+item.totalCost)
        })
    },[cart])
    const { confirm } = Modal;
    const [user,setUser] = useState()
    useEffect(()=>{
        const docRef = doc(db,'users',auth.currentUser.uid)
        getDoc(docRef).then((doc)=>{
            setUser(doc.data())
        })
    },[])
    function showBuyAllConfirm(){
        confirm({
          title: 'Bạn có chắc mua tất cả?',
          icon: <ExclamationCircleOutlined />,
          okText: 'Chắc chắn',
          okType: 'danger',
          cancelText: 'Trở lại',
          onOk() {
            if(user.fullInfo){
                cart.map((item)=>{
                    const docRef = doc(db,'cartlist',auth.currentUser.uid,'cart',item.itemId)
                    deleteDoc(docRef)
                })
                success()
            }else{
                error()
            }
          },
          onCancel() {
            console.log('Cancel');
          },
        });
    }
    function success() {
        Modal.success({
          content: 'Đặt hàng thành công :>',
        });
    }
    function error() {
        Modal.error({
          title: 'Lỗi',
          content: 'Thông tin người dùng không đầy đủ',
        });
    }
    const showInfo = (id)=>{
        navigate(`/home/cartitem?id=${id}`)
    }
    return(
        <>
            <CartContainer>         
                <h3 level={3} className='cart-title'>Giỏ Hàng</h3>
                {cart.length!==0 ? cart.map((item,index)=>(
                    <ProductItem key={index}> 
                        <ImgDiv onClick={()=>showInfo(item.itemId)}>
                            <img src={item.img} className="Item-img"></img>
                        </ImgDiv>
                        <ItemInfo onClick={()=>showInfo(item.itemId)}>
                            <Title level={4} className='cartitem-name'>{item.name}</Title>
                            <OtherInfo>
                                <div style={{display:'flex'}}>
                                    <p className='cartitem-sizenum'>Size: {item.size}</p>
                                    <p className='cartitem-sizenum'>Số Lượng: {item.number}</p>
                                </div>
                                <h5 level={5} className='cartitem-cost'>Đơn Giá: {item.cost}</h5>
                                <h5 level={5} className='cartitem-cost'>Tổng Tiền: {item.totalCost}đ</h5>
                            </OtherInfo>
                        </ItemInfo>
                        <DeleteFilled className="delete-icon" onClick={()=>{
                            let newCart = [...cart]
                            newCart.splice(index,1)
                            setCart(newCart)
                            const docRef = doc(db,'cartlist',auth.currentUser.uid,'cart',item.itemId)
                            deleteDoc(docRef)
                        }}/>
                    </ProductItem>
                )) : <Title level={1} style={{textAlign:"center",marginLeft:'5vw',fontSize:'2.2vmax',marginTop:'3vh'}}>Không có sản phẩm trong giỏ :(</Title>}
            </CartContainer>
            <BuyAllItem>
                <h5 level={5} className='total-title'>Tổng tiền:</h5>
                <h5 level={5} className='total-cost'>{totalCost} đ</h5>
                <Button onClick={showBuyAllConfirm} className='total-btn'>Mua tất cả</Button>
            </BuyAllItem>
        </>
    )
}